import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Truck } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const FIELDS = [["name", "Contact name"], ["phone", "Phone"], ["address1", "Address line 1"], ["address2", "Address line 2 (optional)"], ["town", "Town"], ["county", "County"], ["eircode", "Eircode"]];
const input = "mt-1 w-full border-2 border-slate-200 px-3 py-2 text-sm font-semibold outline-none focus:border-slate-900";

export const DeliveryForm = () => {
  const [form, setForm] = useState({ deliver_to: "home", club_open_hours: false });
  const [saved, setSaved] = useState(false);
  useEffect(() => { api.get("/coach/delivery").then((r) => { if (r.data) { setForm(r.data); setSaved(true); } }); }, []);
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));
  const submit = (e) => {
    e.preventDefault();
    api.put("/coach/delivery", form).then((r) => { setForm(r.data); setSaved(true); toast.success("Club delivery address saved"); }).catch((err) => toast.error(errMsg(err)));
  };
  return (
    <section className="border-2 border-slate-900 bg-white p-5" data-testid="coach-delivery">
      <h2 className="flex items-center gap-2 font-display text-lg font-extrabold uppercase"><Truck className="h-5 w-5" /> Club delivery address</h2>
      <p className="mt-1 text-sm text-slate-600">All your squads' shields are printed together and sent in one delivery – to your home, or to the club if it's open during normal working hours.</p>
      <form onSubmit={submit} className="mt-4 grid gap-3 sm:grid-cols-2">
        <div className="grid grid-cols-2 gap-1 sm:col-span-2" role="radiogroup" aria-label="Deliver to">
          {[["home", "My home"], ["club", "The club"]].map(([k, l]) => (
            <button key={k} type="button" role="radio" aria-checked={form.deliver_to === k} onClick={() => set({ deliver_to: k })} data-testid={`delivery-to-${k}`}
              className={`py-2 text-xs font-bold uppercase ${form.deliver_to === k ? "bg-slate-900 text-white" : "border-2 border-slate-200 hover:border-slate-900"}`}>{l}</button>
          ))}
        </div>
        {form.deliver_to === "club" && (
          <label className="flex items-start gap-2 border-2 border-amber-400 bg-amber-50 p-3 text-xs font-semibold sm:col-span-2">
            <input type="checkbox" checked={!!form.club_open_hours} onChange={(e) => set({ club_open_hours: e.target.checked })} className="mt-0.5 h-4 w-4" data-testid="delivery-club-open-checkbox" />
            I confirm the club is open during normal working hours (Mon–Fri, 9am–5pm) so the courier can deliver.
          </label>
        )}
        {FIELDS.map(([k, label]) => (
          <label key={k} className="text-xs font-bold">{label}
            <input value={form[k] || ""} onChange={(e) => set({ [k]: e.target.value })} required={k !== "address2"} className={input} data-testid={`delivery-${k}-input`} />
          </label>
        ))}
        <button type="submit" className="btn-blaze px-4 py-2.5 text-sm sm:col-span-2 sm:justify-self-start" data-testid="delivery-save-button">{saved ? "Update delivery address" : "Save delivery address"}</button>
      </form>
    </section>
  );
};
